import { MAX_INFANT_AGE } from './config';

export const getChildrenCountByAge = (ages: number[]) => {
  const childCount = ages.filter(age => age > MAX_INFANT_AGE).length;
  const infantCount = ages.filter(age => age <= MAX_INFANT_AGE).length;

  return { childCount, infantCount };
};
